import { BookOutlined } from "@mui/icons-material";
import { Divider, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import LinkConstants from "../../../constants/LinkConstants";
import DashboardWidget from "../Widget/DashboardWidget";
import styles from "./LegalWidget.module.scss";

type Props = {
	className?: string;
};

const LegalWidget = ({ className }: Props) => {
	const { t } = useTranslation("dashboard", { keyPrefix: "legal" });

	return (
		<DashboardWidget className={clsx(styles.widget, className)} title={t("title")}>
			<Divider className={styles.divider} />
			<Trans>
				<Typography className={styles.description}>{t("description")}</Typography>
			</Trans>
			<BriaButtonGroup className={styles.buttons}>
				<BriaButton
					buttonType="textSmall"
					className={styles.textButton}
					startIcon={<BookOutlined />}
					onClick={() => window.open(LinkConstants.LEGAL_LOBBY, "_blank")}
				>
					{t("legalBtn")}
				</BriaButton>
			</BriaButtonGroup>
		</DashboardWidget>
	);
};

export default observer(LegalWidget);
